import type * as React from 'react';
import { del } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import userDeactivated, {
	type UserDeactivatedAction,
} from '@Application/Users/Users/Actions/userDeactivated';
import userDeactivationFailed, {
	type UserDeactivationFailedAction,
} from '@Application/Users/Users/Actions/userDeactivationFailed';
import type DeactivateUser from '@Application/Users/Users/Commands/DeactivateUser';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserDeactivatedAction | UserDeactivationFailedAction;

export default (command: DeactivateUser) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}/activation`,
			);

			const action = userDeactivated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userDeactivationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
